import React, { useState } from 'react';
import axiosClient from '../../axios_client';

const AddAdminGallery = ({ isOpen, onClose, onGalleryItemAdded }) => {
    const [section, setSection] = useState('');
    const [image, setImage] = useState(null);
    const [error, setError] = useState('');

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');

        if (!section || !image) {
            setError('Section and image are required');
            return;
        }

        const formData = new FormData();
        formData.append('section', section);
        formData.append('image', image);

        try {
            await axiosClient.post('/gallery', formData, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('token')}`,
                    'Content-Type': 'multipart/form-data',
                },
            });
            onGalleryItemAdded();
            onClose();
            setSection('');
            setImage(null);
        } catch (err) {
            setError(err.response?.data?.error || 'Failed to add gallery item');
        }
    };

    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 px-4 sm:px-6">
            <div className="bg-white p-4 sm:p-6 rounded-lg shadow-lg w-full max-w-xs sm:max-w-md">
                <h2 className="text-xl sm:text-2xl font-bold mb-3 sm:mb-4 text-[#12392B]">
                    Add Gallery Item
                </h2>
                {error && (
                    <p className="text-red-500 text-sm sm:text-base mb-3 sm:mb-4">
                        {error}
                    </p>
                )}
                <form onSubmit={handleSubmit}>
                    <div className="mb-3 sm:mb-4">
                        <label
                            className="block text-[#12392B] text-sm sm:text-base mb-1 sm:mb-2"
                            htmlFor="section"
                        >
                            Section
                        </label>
                        <select
                            id="section"
                            value={section}
                            onChange={(e) => setSection(e.target.value)}
                            className="w-full p-2 sm:p-3 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-[#E6A71A] text-sm sm:text-base"
                            required
                            aria-label="Section"
                        >
                            <option value="">Select Section</option>
                            <option value="Resort">Resort</option>
                            <option value="Ayurveda">Ayurveda</option>
                            <option value="Restaurant">Restaurant</option>
                            <option value="Beach">Beach</option>
                        </select>
                    </div>
                    <div className="mb-3 sm:mb-4">
                        <label
                            className="block text-[#12392B] text-sm sm:text-base mb-1 sm:mb-2"
                            htmlFor="image"
                        >
                            Image
                        </label>
                        <input
                            type="file"
                            id="image"
                            accept="image/jpeg,image/png"
                            onChange={(e) => setImage(e.target.files[0])}
                            className="w-full p-2 sm:p-3 border border-gray-300 rounded text-sm sm:text-base"
                            required
                            aria-label="Upload Image"
                        />
                    </div>
                    <div className="flex justify-end space-x-2">
                        <button
                            type="button"
                            onClick={onClose}
                            className="bg-gray-500 text-white p-2 sm:p-3 rounded hover:bg-gray-600 transition text-sm sm:text-base"
                        >
                            Cancel
                        </button>
                        <button
                            type="submit"
                            className="bg-[#12392B] text-white p-2 sm:p-3 rounded hover:bg-[#E6A71A] hover:text-[#12392B] transition text-sm sm:text-base"
                        >
                            Add
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default AddAdminGallery;